<div class="PGResourcePicker">
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (!isLoading) {
        @if (customContent) {
            <span (click)="openModal()">
                <ng-content></ng-content>
            </span>
        }
        @if (!customContent) {
            <div class="PGResourcePicker-Selection">
                @for (selection of selectionData; track selection) {
                    @if (selection != null) {
                        @if (viewType == 'Files') {
                            <app-pg-file-preview [fileData]="selection" [viewMode]="fileType"></app-pg-file-preview>
                        }
                        @if (viewType != 'Files') {
                            <app-pg-semantic-view-simplecard [resourceId]="resourceId" [elementData]="selection"></app-pg-semantic-view-simplecard>
                        }
                    }
                }
            </div>
            @if (selectionData.length == 0) {
                <button class="btn btn-primary PGResourcePicker-Add" (click)="openModal()">
                    <i class="fa-regular fa-chevron-right"></i><span>{{ 'pg-resource-picker.select-resource' | locTranslate:'resource':resourceName }}</span>
                </button>
            }
            @if (selectionData.length > 0) {
                <button class="btn btn-sm btn-primary PGResourcePicker-Edit" (click)="openModal()">
                    <i class="fa-regular fa-edit"></i>
                </button>
            }
        }
    }
</div>

<ng-template #modalPicker>
    <div class="modal-header">
        <h4 class="modal-title">{{ 'pg-resource-picker.select-resource' | locTranslate:'resource':resourceName }}</h4>
        <button type="button" class="modal-close btn btn-link" (click)="dismissModal()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="PGResourcePicker-Modal-Body modal-body p-0 px-3">
        <div class="py-3">
            <app-pg-filter-editor-search [resourceId]="resourceId" [status]="filterStatus" [appliedFilter]="appliedFilter" [hasTags]="hasTags" [hasSystemTags]="hasSystemTags" [categoriesOptions]="categoriesOptions" (applySearch)="doApplySearch()"></app-pg-filter-editor-search>
        </div>

        <div>
            <app-pg-resource-embed [customDataService]="customDataService" [resourceId]="resourceId" [relatedResource]="relatedResource" [relatedElement]="relatedElement" [resourceMode]="resourceMode" [filterStatus]="appliedFilter" [selectionMode]="selectionMode || 'single'" [selectionField]="selectionField" [(selection)]="modalSelection" [readOnly]="true"></app-pg-resource-embed>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="dismissModal()">
            {{ 'pg-resource-picker.modal-cancel' | locTranslate }}
        </button>
        <button class="btn btn-primary" (click)="closeModal()">
            {{ 'pg-resource-picker.modal-ok' | locTranslate }}
        </button>
    </div>
</ng-template>
